export enum AssurancesScolaire {
  NomEnfant = 'NOM_ENFANT',
  PrenomEnfant = 'PRENOM_ENFANT',
  DateNaissanceEnfant = 'DATE_ENFANT'
}
